import { render, staticRenderFns } from "./WasWatched_v2.vue?vue&type=template&id=0aa6f16e&"
import script from "./WasWatched_v2.vue?vue&type=script&lang=js&"
export * from "./WasWatched_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WasWatched_v2.vue"
export default component.exports